function defineTax(invoiceItems) {
  const isShipmentIncluded = invoiceItems.some((i) => i.type.includes("Shipment") || i.type.includes("Shipping"));

  return isShipmentIncluded
    ? {
        label: "1.1%",
        value: 0.011,
      }
    : {
        label: "11%",
        value: 0.11,
      };
}
function appendSummaryItems(invoiceItems, options = {}) {
  let result;
  const { tax = defineTax(invoiceItems), useGrossPrice = true } = options;

  const items = useGrossPrice
    ? invoiceItems
    : invoiceItems.map((i) => ({
        ...i,
        grossPrice: Math.round((tax.value + 1) * i.price),
      }));

  const otherFees = items.reduce((r, i) => r + parseInt(i.cashOnDeliveryFee || 0), 0);

  const subTotalItem = {
    type: "",
    service: "",
    details: "",
    quantity: `Subtotal${tax.label === "1.1%" ? " Shipping" : ""}`,
    price: items.reduce((r, i) => r + parseInt(i.price), 0) - otherFees,
  };

  const grandTotalItem = {
    type: "",
    service: "",
    details: "",
    quantity: "Grand Total",
    price: Math.round(
      useGrossPrice
        ? items.reduce((r, i) => r + parseInt(i.grossPrice), 0)
        : subTotalItem.price * (tax.value + 1)
    ),
  };

  const vatItem = {
    type: "",
    service: "",
    details: "",
    quantity: `VAT (${tax.label})`,
    price: Math.round(grandTotalItem.price - subTotalItem.price),
  };

  result = [...items, subTotalItem, vatItem, grandTotalItem];
  return result;
}

function appendBillPaidUnpaid(invoice) {
  const tax = defineTax(invoice.items);

  const paidBill = {
    type: "",
    service: "",
    details: "",
    quantity: "Sudah Terbayarkan",
    price: Math.round(invoice.paidOrderBill * (1 + tax.value)),
  };

  const unpaidBill = {
    type: "",
    service: "",
    details: "",
    quantity: "Sisa Pembayaran",
    price: Math.round((invoice.total - invoice.paidOrderBill) * (1 + tax.value)),
  };

  return [paidBill, unpaidBill];
}

const checkItems = (items) => {
  let isShippingIncluded = false;
  let isOtherIncluded = false;

  for (let i = 0; i < items.length; i++) {
    let item = items[i];

    if (item.type.includes("Shipment")) {
      isShippingIncluded = true;
      continue;
    }

    isOtherIncluded = true;

    if (isShippingIncluded && isOtherIncluded) break;
  }

  return {
    isShippingIncluded,
    isOtherIncluded,
  };
};

const summarizeShipmentSolutionItems = (items) => {
  const invoiceItems = appendSummaryItems(items, {
    useGrossPrice: false,
  });
  const otherfees = countOtherFees(items);
  const item = {
    type: "Shipment Solutions",
    quantity: 0,
    price: 0,
  };
  // Exclude Subtotal, VAT, and Grand Total
  // Summarize Price on Shipment Solutions
  invoiceItems.slice(0, -3).forEach((i) => {
    item.quantity += parseInt(i.quantity || 0);
    item.price += parseInt(i.price || 0);
  });

  // To split otherfees from Shipment Invoice
  if (otherfees > 0) item.price -= otherfees;

  return [item, ...invoiceItems.slice(-3)];
};

const summarizeShippingItems = (items) => {
  const invoiceItems = appendSummaryItems(items, {
    useGrossPrice: false,
  });
  const otherfees = countOtherFees(items);
  const item = {
    type: "Shipping",
    quantity: 0,
    price: 0,
  };

  // Exclude Subtotal, VAT, and Grand Total
  // Summarize Price on Shipment Solutions
  invoiceItems.slice(0, -3).forEach((i) => {
    item.quantity += parseInt(i.quantity || 0);
    item.price += parseInt(i.price || 0);
  });

  // To split otherfees from Shipment Invoice
  if (otherfees > 0) item.price -= otherfees;

  return [item, ...invoiceItems.slice(-3)];
};

const summarizeOtherItems = (items) => {
  const invoiceItems = appendSummaryItems(items, {
    useGrossPrice: false,
  });

  const summarizedItems = [];

  const fulfillmentSummary = {
    quantity: 0,
    price: 0,
  };

  const fulfillmentItems = [];

  const ratesSummary = {
    quantity: 0,
    price: 0,
  };

  const ratesItems = [];

  const trackingSummary = {
    quantity: 0,
    price: 0,
  };

  const trackingItems = [];

  const subscriptionSummary = {
    quantity: 0,
    price: 0,
  };

  const subscriptionItems = [];

  const customItems = [];

  // Exclude Subtotal, VAT, and Grand Total
  // Summarize Price on Shipment Solutions
  invoiceItems.slice(0, -3).forEach((i) => {
    if (i.type.includes("Fulfillment")) {
      fulfillmentSummary.price += parseInt(i.price);
      fulfillmentSummary.quantity += parseInt(i.quantity);

      fulfillmentItems.push(i);
      return;
    }

    if (i.type.includes("Rates")) {
      ratesSummary.price += parseInt(i.price);
      ratesSummary.quantity += parseInt(i.quantity);

      ratesItems.push(i);
      return;
    }

    if (i.type.includes("Tracking")) {
      trackingSummary.price += parseInt(i.price);
      trackingSummary.quantity += parseInt(i.quantity);

      trackingItems.push(i);
      return;
    }

    if (i.type.includes("Subscription")) {
      subscriptionSummary.price += parseInt(i.price);
      subscriptionSummary.quantity += parseInt(i.quantity);

      subscriptionItems.push(i);
      return;
    }

    customItems.push(i);
  });

  if (fulfillmentItems.length > 0)
    summarizedItems.push({
      type: "Fulfillment",
      ...fulfillmentSummary,
    });

  if (ratesItems.length > 0)
    summarizedItems.push({
      type: "Rates",
      ...ratesSummary,
    });

  if (trackingItems.length > 0)
    summarizedItems.push({
      type: "Tracking",
      ...trackingSummary,
    });

  if (subscriptionItems.length > 0)
    summarizedItems.push({
      type: "Subscription",
      ...subscriptionSummary,
    });

  return [...summarizedItems, ...customItems, ...invoiceItems.slice(-3)];
};

const invoiceToPDF = (invoice) => {
  const iInvoice = { ...invoice };
  const invoiceItems = iInvoice.items;
  const { isShippingIncluded, isOtherIncluded } = checkItems(invoiceItems);

  if (isShippingIncluded && isOtherIncluded) {
    iInvoice.items = summarizeShipmentSolutionItems(invoiceItems);
    if (iInvoice.paidOrderBill > 0) {
      iInvoice.items = [...iInvoice.items, ...appendBillPaidUnpaid(iInvoice)];
    }
    return iInvoice;
  }

  if (isShippingIncluded && !isOtherIncluded) {
    iInvoice.items = summarizeShippingItems(invoiceItems);
    if (iInvoice.paidOrderBill > 0) {
      iInvoice.items = [...iInvoice.items, ...appendBillPaidUnpaid(iInvoice)];
    }
    return iInvoice;
  }

  iInvoice.items = summarizeOtherItems(invoiceItems);
  if (iInvoice.paidOrderBill > 0) {
    iInvoice.items = [...iInvoice.items, ...appendBillPaidUnpaid(iInvoice)];
  }
  return iInvoice;
};

const countOtherFees = (items) => {
  return items.reduce(
    // NOTE: 18 December 2023: We only need to use COD Fee
    // (r, i) => r + parseInt(i.insuranceFee || 0 + i.cashOnDeliveryFee || 0 + i.proofOfDeliveryFee || 0 + i.additionalFee || 0),
    (r, i) => r + parseInt(i.cashOnDeliveryFee || 0),
    0
  );
};

export default {
  invoiceToPDF,
  countOtherFees,
  defineTax
};
